require('./src/styles/global.css');

const smoothscroll = require('smoothscroll-polyfill');

exports.shouldUpdateScroll = ({
  prevRouterProps: { location: prevLocation } = {},
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const { pathname } = location;
  const scrollToTopRoutes = ['', 'blog', 'post', 'news', 'jobs', 'job', 'benefit'];
  const rootPath = pathname.split('/')[1];

  if (scrollToTopRoutes.indexOf(rootPath) !== -1) {
    // restore scroll in routing by team filter selection
    if (rootPath === 'jobs' && prevLocation?.pathname === pathname) {
      const savedPosition = getSavedScrollPosition(prevLocation);

      window.requestAnimationFrame(() => {
        window.scrollTo(...savedPosition);

        // sync stored scroll data
        if (prevLocation.key !== location.key) {
          sessionStorage.setItem(`@@scroll|${pathname}|${location.key}`, `${savedPosition[1]}`);
        }
      });

      return true;
    }

    // restore scroll when return to jobs page from job detail page
    if (rootPath === 'jobs' && prevLocation?.pathname.startsWith('/job/')) {
      const savedPosition = getSavedScrollPosition(location);

      window.requestAnimationFrame(() => {
        window.scrollTo(...savedPosition);
      });

      return true;
    }

    window.requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }

  return false;
};

exports.onClientEntry = () => {
  smoothscroll.polyfill();
  
  // OneTrust 스크립트 동적 로드
  if (typeof window !== 'undefined') {
    // OtAutoBlock.js 로드
    const autoBlockScript = document.createElement('script');
    autoBlockScript.type = 'text/javascript';
    autoBlockScript.src = 'https://cdn.cookielaw.org/consent/4fc38fa8-d611-42a1-9d02-384e1c3d566d/OtAutoBlock.js';
    document.head.appendChild(autoBlockScript);

    // OneTrust SDK 로드
    const sdkScript = document.createElement('script');
    sdkScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    sdkScript.type = 'text/javascript';
    sdkScript.charset = 'UTF-8';
    sdkScript.setAttribute('data-domain-script', '4fc38fa8-d611-42a1-9d02-384e1c3d566d');
    document.head.appendChild(sdkScript);

    // OptanonWrapper 함수 정의
    window.OptanonWrapper = function() {};
    
    // 디버그용 로그
    console.log('OneTrust scripts loaded');
    
    // OneTrust가 로드되었는지 확인하는 함수
    const checkOneTrust = () => {
      if (window.OneTrust) {
        console.log('OneTrust is available:');
      } else {
        console.log('OneTrust not yet available');
        setTimeout(checkOneTrust, 1000);
      }
    };
    
    setTimeout(checkOneTrust, 2000);
  }
};
